import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { Col, Row, Button, Input } from 'reactstrap';
import ShiftTable from './ShiftTable';
import { addShift, getShifts } from 'store/actions';
import CreateShift from './CreateShift';
import Breadcrumb from 'components/Common/Breadcrumb2';

const ShiftList = () => {
    const [selectedGroup, setselectedGroup] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const optionGroup = [
        {
            label: "Picnic",
            options: [
                { label: "Mustard", value: "Mustard" },
                { label: "Ketchup", value: "Ketchup" },
                { label: "Relish", value: "Relish" }
            ]
        },
        {
            label: "Camping",
            options: [
                { label: "Tent", value: "Tent" },
                { label: "Flashlight", value: "Flashlight" },
                { label: "Toilet Paper", value: "Toilet Paper" }
            ]
        }
    ];

    const dispatch = useDispatch();
    const shifts = useSelector((state) => state.Shift.shifts);
    const loading = useSelector((state) => state.Shift.loading);
    const error = useSelector((state) => state.Shift.error);

    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    // Dispatch action to fetch catalog items when component mounts
    useEffect(() => {
        if(loading)return;
        dispatch(getShifts()); 
    }, [dispatch]);

    const handleSelectGroup = (selectedOption) => {
        setselectedGroup(selectedOption);
    };

    const handleSubmit = (data) => {
        dispatch(addShift(data));
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
        <CreateShift visible={isOpen} onSubmit={handleSubmit} handleClose={handleClose} />
        <div className='page-content container-fluid'>
            <div className='d-flex justify-content-between align-items-center mx-3'>
                <Breadcrumb title="Shifts" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Shifts", link: '#' }]} />
                {permissions2?.map(item=>item?.permissionName)?.includes("Add Shifts") && <Button className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center' onClick={() => setIsOpen(true)}>
                    <i className='ti-plus'></i> Add New
                </Button>}
            </div>
            <Row className='ms-2'>
                <Col lg={4}>
                    <Row className="mb-3">
                        {/* <Col xs={6}>
                            <div className="">
                                <Select
                                    value={selectedGroup}
                                    onChange={handleSelectGroup}
                                    options={optionGroup}
                                    classNamePrefix="select2-selection"
                                    placeholder="Status"
                                />
                            </div>
                        </Col>
                        <Col xs={6}>
                            <div className="">
                                <Select
                                    value={selectedGroup}
                                    onChange={handleSelectGroup}
                                    options={optionGroup}
                                    classNamePrefix="select2-selection"
                                    placeholder="Team"
                                />
                            </div>
                        </Col> */}
                    </Row>
                </Col>
                <Col className="mb-3" lg={8}>

                </Col>
            </Row>
            <ShiftTable loading={loading} List={shifts?.Data} />
        </div>
        </>
    );
};

export default ShiftList;
